import { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn, dispatchLead } from "../../lib/utils";
import icon from "../../assets/icons/whatsapp.svg";
import externalIcon from "../../assets/icons/external.svg";

export type WhatsappButtonProps = ComponentPropsWithoutRef<"a"> & {
  href: string;
  ariaLabel: string;
  hideLeftIcon?: boolean;
  hideRightIcon?: boolean;
  children: ReactNode;
};

export const WhatsappButton = ({
  href,
  ariaLabel,
  className,
  children,
  hideLeftIcon,
  hideRightIcon,
  ...props
}: WhatsappButtonProps) => {
  return (
    <a
      role="button"
      className={cn("cta-button", className)}
      aria-label={ariaLabel}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={dispatchLead()}
      {...props}
    >
      <span className="flex items-center gap-2 justify-center">
        {!hideLeftIcon && (
          <img src={icon} alt="Ícone WhatsApp" className="w-7 h-7" />
        )}
        {children}
        {!hideRightIcon && (
          <img src={externalIcon} alt="Ícone externo" className="w-6 h-6" />
        )}
      </span>
    </a>
  );
};
